import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

import FormField from "../../../../../_artifact/components/forms/FormField";
import SubmitButton from "../../../../../_artifact/components/forms/SubmitButton";
import { fetchForgotPassword, updateAuthError } from "../..";
import jsonHelper from "../../../../../_artifact/helpers/jsonHelper";
import Modal from "../../../../../_artifact/components/Modal";


const initialValues = {
  email: "",
};


function ForgotPassword({ history }) {
  const [ismailsent, setIsmailsent] = useState(false);
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => ({ auth: state.auth }), shallowEqual);
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Required field"),
  });

  const handleSubmit = (values) => {
    dispatch(
      fetchForgotPassword(jsonHelper.jsonToForm({ email: values.email }))
    )
      .then(() => {
        setIsmailsent(true);
        
        })
        //
      .catch((error) => {
        if (error.response && error.response.data)
          error.clientMessage = error.response.data.message;
        else error.clientMessage = "Can't send Email.";
        dispatch(updateAuthError(error));
      });
  };

  return (
    <div className="auth-wrap">
      <div className="auth-box">
        <h2 className="auth-title desktop-only">Forgot Password</h2>

        <div className="page-title-inner mobile-only">
          <Link to="/profile">
            <img src="/assets/images/left-arrow.svg" alt="" />
          </Link>
          <h2>Forgot Password</h2>
        </div>

        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          <form className="form-wrap">
            <div className="form-body">
              <div className="form-group">
                <FormField
                  name="email"
                  label="Email ID"
                  placeholder="Enter email"
                />
              </div>
            </div>
            <div className="form-footer">
              <SubmitButton title="SUBMIT" disabled={auth.loading} />
            </div>
          </form>
        </Formik>
      </div>
      <Modal
        isOpen={ismailsent}
        action={"OK"}
        title={"We have just sent you an email to reset your password. Please check!"}
        onClose={() => {
          setIsmailsent(false);
          history.replace("/auth/login");
        }}
      />
    </div>
  );
}

export default ForgotPassword;
